<template>
  <div class="fancy-check">
    <icon-check />
  </div>
</template>